module.exports = __webpack_public_path__ + "static/media/site.957f30ac.proto";